// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__C26Ee","formError":"styles_formError__2RnaG"};